/* @flow */

import React, { Fragment } from 'react'
import { parseISO } from 'date-fns'
import i18n from 'atpjs/helpers/i18n'
import { formatTime, dayWithDateTime } from 'tve/helpers/date'
import { formatPhone, formatPhoneForTel } from 'tve/helpers/phone'

const t = i18n.prefix(['components', 'appointmentSummary'])

const computeBranch = (advisor, branchSource) => {
  return advisor && advisor.get('branches')
    ? advisor.get('branches').find((branch) => branch.get('id') === branchSource.get('id'))
    : branchSource
}

const Address = ({ branch, medium }) => {
  if (!branch) {
    return null
  }

  const branchName = medium === 'bank' ? `${branch.get('name')}, ` : null

  return (
    <Fragment>
      {branchName}
      {branch.get('street')}, {branch.get('zip')} {branch.get('city')}
    </Fragment>
  )
}

const AppointmentSummary = (props) => {
  const { advisor, branch: branchSource, customerType, medium, value } = props
  const start = value.get('start')
  const end = value.get('end')

  const displayAddress = ['bank', 'personal'].includes(medium)
  const branch = displayAddress ? computeBranch(advisor, branchSource) : null
  const phoneNumber = (advisor && advisor.get('phoneNumber')) || (branch && branch.get('phoneNumber')) || null

  return (
    <div className="atp-box atp-box--neutral atp-margin-top-s">
      {start && end && (
        <Fragment>
          <p className="atp-margin-bottom-no atp-bold">{t(['yourSelection'])}</p>
          <p className="atp-margin-bottom-s">
            {t(['whenTime'], {
              time: dayWithDateTime(parseISO(start)),
              until: formatTime(parseISO(end))
            })}
          </p>
        </Fragment>
      )}

      <p className="atp-margin-bottom-no atp-bold">{t(['where'])}</p>
      {displayAddress && <Address branch={branch} medium={medium} />}
      <p className="atp-margin-bottom-s">
        {medium == 'phone' && t(['phone'])}
        {medium == 'personal' && customerType == 'corporate' && t(['atYourCompany'])}
        {medium == 'personal' && customerType == 'private' && t(['atYourHome'])}
      </p>

      {phoneNumber && (
        <Fragment>
          <p className="atp-margin-bottom-no atp-bold">{t(['anyQuestions'])}</p>
          <p className="atp-margin-bottom-no">
            <a href={`tel:${formatPhoneForTel(phoneNumber)}`}>{formatPhone(phoneNumber)}</a>
          </p>
        </Fragment>
      )}
    </div>
  )
}

export default AppointmentSummary
